import React from "react";
import { classNames } from "@/utils/utils";

import styles from "./DotsLoader.module.css";

type Props = {
  className?: string;
};
export const DotsLoader: React.FC<Props> = ({ className }) => {
  return (
    <div className={classNames(styles.loader, className)}>
      <div className={classNames(styles.dot, styles.dot1)} />
      <div className={classNames(styles.dot, styles.dot2)} />
      <div className={classNames(styles.dot, styles.dot3)} />
      <span className={styles.hidden}>loading...</span>
    </div>
  );
};
